module.exports = __webpack_public_path__ + "img/calculator.514e7b34.jpg";